import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {PartitionOPEEnum} from "./PartitionOPEEnum";

/**
 * O Inner Class
 */
class O {
}

/**
 * I Inner Class
 */
class I {
  id!: number;
  parentId!: number;
}

export class UpdateParentPartitionCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(PartitionOPEEnum.UpdateParentPartition);
    this.i = new I();
    this.o = new O();
  }
}
